<style src="./../../assets/styles.css"></style>
<style src="./../../assets/responsive.css"></style>
<template>
    <div >
        <div class="go_to_contact">
            <div @click="goToContact" class="is-animating">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        },
        methods: {
            goToContact () {
                this.$router.push('/contact')
            }
        }
}
</script>